/*=========================================================================================
  File Name: moduleAuthActions.js
  Description: Auth Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: BCC Pubs
  Author: SweetAs
  Author URL: http://sweetas.xyz
==========================================================================================*/

import jwt from '../../http/requests/auth/jwt/index.js'

import router from '@/router'
const { isNavigationFailure, NavigationFailureType } = router

export default {  

  // JWT
  loginJWT ({ commit }, payload) {

    return new Promise((resolve, reject) => {
      jwt.login(payload)
        .then(response => {          
          // If there's user data in response
          const d = response.data
          debugger
          if (d.data == '[]') { 
            reject({message: 'Invalid Username / Password'})
          }
          if (d.data != '[]' && d.data.includes('access')) {            
            const j = JSON.parse(d.data)            
            if (j.access !== 'x')  {              
              // Set accessToken
              localStorage.setItem('accessToken', d.token)   
              commit('UPDATE_USER_DETAILS', j,  {root: true})
              commit('UPDATE_USER_ACCESS', d,  {root: true})
              commit('SET_BEARER',  d.token)
              debugger
              // forcereset              
              if(j.forcereset=='1'){
                const rou = `/reset/${ j.guid}`
                router.push(rou)
              }
              if(j.forcereset =='0'){
                router.push('/search').catch(failure => {
                  if (isNavigationFailure(failure, NavigationFailureType.redirected)) {
                    // show a small notification to the user                  
                  }
                })
              }
              resolve(response)
            }
            reject({message: 'Invalid Password'})
          } else {
            reject({message: 'Something Went Wrong'})
          }

        })
        .catch(error => { reject(error) })
    })
  },

   // JWT
   loginUiJWT (ctx, payload) {    
    return new Promise((resolve, reject) => {
      jwt.loginUi(payload)
        .then(response => {
           resolve(response)   
        })
        .catch(error => { reject(error) })
    })
  },
  resetPw ( commit, payload) {

    return new Promise((resolve, reject) => {
      jwt.reset(payload)
        .then(response => {             
           resolve(response)
        })
        .catch(error => { reject(error) })
    })
  },
  fetchAccessToken () {
    return new Promise(resolve => {
      jwt.refreshToken().then(response => { resolve(response) })
    })
  }
}
